import React from 'react';
import PropTypes from 'prop-types';
import style from './style';

class TableHeader extends React.Component {
    state = {};

    constructor(props) {
        super(props);
        this.state = {sortColumn: props.sortColumn};
    }

    setSorting = (columnName) => {
        if ('actions' === columnName) {
            return false;
        }
        if (columnName === this.state.sortColumn.columnName) {
            return (
                <i className={'fa fa-sort-' + this.state.sortColumn.order}></i>
            );
        }
        return <i className="fa fa-sort"></i>;
    };
    onChangeOrder = (columnName) => {

        let sortColumn = {};

        if (this.state.sortColumn && columnName === this.state.sortColumn.columnName) {
            sortColumn.columnName = columnName;
            if ('asc' === this.state.sortColumn.order) {
                sortColumn.order = 'desc';
            } else {
                sortColumn.order = 'asc';
            }
        } else {
            sortColumn = {columnName: columnName, order: 'asc'};
        }

        this.setState({sortColumn});
        this.props.onChangeOrder(sortColumn);
    };

    render() {
        const { column, header, sortColumn, onKeyUp } = this.props;
        const { sortColumn: stateSort } = this.state;

        return (
            <thead>
            <tr>
                {column.map((columnName, key) => {
                    const cell = header[columnName];
                    const isSortable = columnName !== 'actions';

                    return (
                        <th
                            key={key}
                            className={`filter-th ${cell.filter ? 'has-filter' : ''}`}
                            onClick={() => isSortable && this.onChangeOrder(columnName)}
                        >
                            <div className="th-content">
                                <span className="th-title">{cell.name}</span>

                                {isSortable && (
                                    <span className="th-icons">
                    {this.setSorting(columnName)}
                                        {cell.filter && <i className="fa fa-filter filter-icon" />}
                  </span>
                                )}
                            </div>
                        </th>
                    );
                })}
            </tr>

            {onKeyUp && (
                <tr className="filter-row">
                    {column.map((columnName, key) => {
                        const cell = header[columnName];

                        return (
                            <th key={key} style={cell.style}>
                                {cell.filter && (
                                    <input
                                        className="form-control form-control-sm filter-input"
                                        id={columnName}
                                        name={columnName}
                                        placeholder={`Filter`}
                                        onKeyUp={onKeyUp}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                )}
                            </th>
                        );
                    })}
                </tr>
            )}
            </thead>
        );
    }
}

TableHeader.propTypes = {
    column: PropTypes.array.isRequired,
    header: PropTypes.object.isRequired,
    sortColumn: PropTypes.object,
    onKeyUp: PropTypes.func,
    onChangeOrder: PropTypes.func,
};

export default TableHeader;
